import ResendVerificationEmailForm from "../../components/resend-verification-email";

export default function ResendVerificationEmailPage() {

    return <div className='verification-email-page-container'>
        <ResendVerificationEmailForm />
    </div>
}